import {
  IS_SERVER_ENVIRONMENT,
  assertShellRequirements,
} from "@aviv-unified-frontend/internal";

import { IS_DEV_LIKE_ENVIRONMENT } from "../../constants/environment";
import { withErrorBoundary } from "../../components/ErrorBoundary";
import type { GetRemoteApplication } from "../types";

/**
 * Get a remote component (can be either a white-label application or a micro frontend).
 */
export const getRemoteApplication: GetRemoteApplication = (input) => {
  const {
    id,
    exports: { App, default: createApplication },
  } = input;

  if (!IS_SERVER_ENVIRONMENT && IS_DEV_LIKE_ENVIRONMENT) {
    assertShellRequirements(id, Boolean(createApplication));
  }

  const AppFromLifecycle = createApplication?.Component;

  if (!App && !AppFromLifecycle) {
    throw new Error(
      `Unable to find the exported remote component. Make sure the registry is configured correctly to import an existing component.`,
    );
  }

  if (AppFromLifecycle) {
    return {
      ...createApplication,
      Component: AppFromLifecycle,
    };
  }

  return {
    ...createApplication,
    Component: withErrorBoundary({ name: `withErrorBoundary_${id}` })(App),
  };
};
